import { render, staticRenderFns } from "./LeagueMypage.vue?vue&type=template&id=5b769c1c&"
import script from "./LeagueMypage.vue?vue&type=script&lang=js&"
export * from "./LeagueMypage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports